import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from 'react-router-dom';
import PropTypes from "prop-types";
import PostForm from "./PostForm";
import PostControl from "./PostControl";
import InfiniteScroll from "react-infinite-scroll-component";
import { addPost, loadUserPosts, loadGroupPosts, loadEventPosts, loadNewsFeed } from "../../redux/actions/postCommentActions";
import Spinner from "../common/Spinner";
import "./PostComment.css"

function PostFeedControl({
    user,
    mode,
    active = true,
    loadUserPosts,
    loadGroupPosts,
    loadEventPosts,
    loadNewsFeed,
    addPost,
    userRefId,
    subjectUserId,
    refId,
    history
}) {

    const [posts, setPosts] = useState({ results: [] });
    const [postDetails, setPostDetails] = useState({ body: "", images: [] });
    const [errors, setErrors] = useState({});
    const [processing, setProcessing] = useState(true);
    const [fetching, setFetching] = useState(false);

    useEffect(() => {
        if (posts.results.length == 0) {
            fetchMoreData();
        }
    }, []);

    useEffect(() => {

    }, [posts])


    function fetchMoreData() {
        if (fetching) {
            return; 
        }
        setFetching(true); 
        var criteria = {
            postType: mode,
            itemReferenceId: refId,
            pageNumber: posts.results.length > 0 ? posts.currentPage + 1 : 1,
            numberOfResults: "5",
            sortDirection: "DESC",
            sortBy: "LastActive"
        };

        switch (mode) {
            case "User":
                if (subjectUserId) {
                    criteria.UserReferenceId = subjectUserId; 
                }
                loadUserPosts(criteria)
                    .then((postResults) => {
                        postResults.results = posts.results.concat(postResults.results);
                        setFetching(false); 
                        setPosts(postResults);
                        if (processing) {
                            setProcessing(false);
                        }

                    })
                    .catch((error) => {
                        switch (error.message) {
                            case "401":
                                history.push("/resourceunavailable");
                                break;
                            case "404":
                                history.push("/lost");
                                break;
                        }
                    })
                break;
            case "News":
                loadNewsFeed(criteria)
                    .then((postResults) => {
                        postResults.results = posts.results.concat(postResults.results);
                        setFetching(false);  
                        setPosts(postResults);
                        if (processing) {
                            setProcessing(false);
                        }

                    })
                    .catch((error) => {
                        switch (error.message) {
                            case "401":
                                history.push("/resourceunavailable");
                                break;
                            case "404":
                                history.push("/lost");
                                break;
                        }
                    })
                break;
            case "Group":
                loadGroupPosts(criteria)
                    .then((postResults) => {
                        postResults.results = posts.results.concat(postResults.results);
                        setFetching(false); 
                        setPosts(postResults);
                        if (processing) {
                            setProcessing(false);
                        }
                        
                    })
                    .catch((error) => {
                        switch (error.message) {
                            case "401":
                                history.push("/resourceunavailable");
                                break;
                            case "404":
                                history.push("/lost");
                                break;
                        }
                    })
                break;
            case "Event":
                loadEventPosts(criteria)
                    .then((postResults) => {
                        postResults.results = posts.results.concat(postResults.results);
                        setFetching(false);  
                        setPosts(postResults);
                        if (processing) {
                            setProcessing(false);
                        }
                    })
                    .catch((error) => {
                        switch (error.message) {
                            case "401":
                                history.push("/resourceunavailable");
                                break;
                            case "404":
                                history.push("/lost");
                                break;
                        }
                    })
                break;
        }
    }

    function handlePostChange(e) {
        var { name, value } = e.target;
        setPostDetails(prevPostDetails => ({
            ...prevPostDetails,
            [name]: value
        }));
    }

    function handleImagesChange(images){
        setPostDetails(prevPostDetails => ({
            ...prevPostDetails,
            images: images
        }));
    }

    function onPostSave(e) {
        e.preventDefault();
        const errors = {};

        setProcessing(true);

        if (!postDetails.body) {
            errors.name = "Please enter something!";
            setErrors(errors);
            return;
        }
        var newPost = { body: postDetails.body, images: postDetails.images };

        newPost.postType = mode === "News" ? "User" : mode;
        newPost.authorId = user.id;
        newPost.authorFirstName = user.firstName;
        newPost.authorSurname = user.surname;
        newPost.authorHasAvatar = user.avatarAvailable; 
        if (mode === "User") {
            newPost.userReferenceId = userRefId;
        } else {
            newPost.itemReferenceId = refId;
        }
        newPost.postedOn = new Date();

        addPost(newPost)
            .then((postSaveDetails) => {
                newPost.id = postSaveDetails.id;
                newPost.images = postSaveDetails.images;

                var refreshedPosts = []
                refreshedPosts.push(newPost);
                posts.results.map(p => {
                    refreshedPosts.push(p); 
                })

                setPosts(prevPosts => ({
                    ...prevPosts,
                    results: refreshedPosts
                }));

                setPostDetails(prevPostDetails => ({
                    ...prevPostDetails,
                    body: "",
                    images: []
                }));
                newPost.commentCount = 0;
                newPost.userReactions = { itemType: "Post", itemId: postSaveDetails.id, users: [] };
                setProcessing(false);
                
            }).catch(error => {
                setProcessing(false);
                setErrors({ onSave: error.message });
            });

    }

    function handlePostDeleted(post) {
        var refreshedPosts = []
        posts.results.map(p => {
            if (p.id != post.id) {
                refreshedPosts.push(p);
            }
        })

        setPosts(prevPosts => ({
            ...prevPosts,
            results: refreshedPosts
        }));
    }

    function handlePostEdited(post) {
        var refreshedPosts = []
        posts.results.map(p => {
            if (p.id == post.id) {
                refreshedPosts.push(post);
            } else {
                refreshedPosts.push(p);
            }
        })

        setPosts(prevPosts => ({
            ...prevPosts,
            results: refreshedPosts
        }));
    }

    

    return (
            <div className="row justify-content-center ml-0 mr-0">
                <div className="top-form col-12">
                    <div className="row justify-content-center">
                        {active && !subjectUserId &&
                        <div className="post-form col-12 col-sm-8">
                            <PostForm post={postDetails} user={user} placeholder="Post Something..." onSave={onPostSave} saving={processing} onChange={handlePostChange} onImagesChange={handleImagesChange} errors={errors} />
                            </div>
                        }
                    </div>
                </div>
                {processing ?
                    <Spinner /> :
                    <div className="post-feed col-12">
                    <div className="row justify-content-center">
                        <div className="post-feed-items">
                        {(posts.results.length === 0) &&
                            <div className="empty-message">
                                <span className="fas fa-clock empty-icon mt-5"></span>
                                <div className="empty-text">There are no posts to show yet!</div>
                            </div>
                        }
                        <InfiniteScroll
                            dataLength={posts.results.length}
                            next={fetchMoreData}
                            hasMore={posts.results.length < posts.totalResults}
                            pullDownToRefresh={false}
                            loader={
                                <div className="post-infinity-loading">
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    <span> Loading...</span>
                                </div>
                            }
                        >
                            {posts.results.map(post => {
                                return (
                                    <PostControl key={post.id} post={post} onPostDeleted={handlePostDeleted} onPostEdited={handlePostEdited} active={active} />
                                )
                            })}
                            </InfiniteScroll>
                        </div>
                    </div>
                </div>
                }
            </div>
            
    );

}

PostFeedControl.propTypes =
{
    user: PropTypes.object.isRequired,
    mode: PropTypes.string.isRequired,
    active: PropTypes.bool,
    userRefId: PropTypes.object,
    subjectUserId: PropTypes.string,
    refId: PropTypes.number,
    loadUserPosts: PropTypes.func,
    loadGroupPosts: PropTypes.func,
    loadEventPosts: PropTypes.func,
    loadNewsFeed: PropTypes.func,
    addPost: PropTypes.func.isRequired,
    errorMessage: PropTypes.string
}


function mapStateToProps(state) {
    return {
        user: state.user
    };
}

const mapDispatchToProps = {
    addPost,
    loadUserPosts,
    loadGroupPosts,
    loadEventPosts,
    loadNewsFeed
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostFeedControl)); 


// WEBPACK FOOTER //
// ./src/components/postComments/PostFeedControl.js